// assets.js — Klaren brand media (videos hotlinked from permanent public CDN)
export const VIDEOS = {
  hero: "https://customer-assets.emergentagent.com/job_builder-hub-655/artifacts/bd16lkn5_hf_20260428_193507_4286c423-2fd9-4efd-92bd-91a939453fc1.mp4",
  touch: "https://customer-assets.emergentagent.com/job_builder-hub-655/artifacts/lrf18nza_hf_20260511_230229_7c9bc431-46cf-489a-948d-e8144d8eb5d4.mp4",
  leaveBehind: "https://customer-assets.emergentagent.com/job_builder-hub-655/artifacts/7s3hyp60_hf_20260514_135830_bb6491d1-9b66-4aec-9722-13b4dfe3fb46.mp4",
};
